/**
 * WorkspaceLinkForm — formulaire générique pour lier un outil Google Workspace
 * (Calendar, Keep, Docs) à un master_client + expertise.
 *
 * Extrait de Bureau.jsx (Batch #14.221 — refactor oversized 2026-02).
 */
import { useState } from "react";
import axios from "axios";
import { Loader2, Save } from "lucide-react";
import { toast } from "@/lib/toast";
import { API, authH } from "@/api";


export default function WorkspaceLinkForm({ tool, masterId, expertise, initialUrl, placeholder, tip, onCancel, onSaved }) {
  const [url, setUrl] = useState(initialUrl || "");
  const [busy, setBusy] = useState(false);
  const toneByTool = {
    calendar: { ring: "focus:ring-emerald-400", border: "border-emerald-200 focus:border-emerald-400", btn: "bg-emerald-600 hover:bg-emerald-700" },
    keep:     { ring: "focus:ring-amber-400",   border: "border-amber-200 focus:border-amber-400",     btn: "bg-amber-600 hover:bg-amber-700" },
    docs:     { ring: "focus:ring-blue-400",    border: "border-blue-200 focus:border-blue-400",       btn: "bg-blue-600 hover:bg-blue-700" },
  }[tool] || { ring: "focus:ring-slate-400", border: "border-slate-200", btn: "bg-slate-600 hover:bg-slate-700" };

  const save = async () => {
    const trimmed = (url || "").trim();
    if (!trimmed) {
      toast.error("Collez l'URL");
      return;
    }
    setBusy(true);
    try {
      await axios.put(
        `${API}/masters/${masterId}/expertises/${expertise}/workspace-tool/${tool}/link`,
        { url: trimmed },
        { headers: authH() },
      );
      toast.success("Lié ✓");
      onSaved?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erreur — URL invalide");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-3 space-y-2" data-testid={`bureau-${tool}-link-form`}>
      <input
        type="url"
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        placeholder={placeholder}
        className={`w-full px-2.5 py-1.5 text-xs border rounded-lg focus:ring-2 outline-none ${toneByTool.border} ${toneByTool.ring}`}
        data-testid={`bureau-${tool}-link-input`}
        autoFocus
      />
      <div className="flex items-center gap-1.5">
        <button
          onClick={save}
          disabled={busy}
          className={`px-2.5 py-1.5 rounded-lg text-white text-xs inline-flex items-center gap-1.5 disabled:opacity-40 ${toneByTool.btn}`}
          data-testid={`bureau-${tool}-link-save`}
        >
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Save className="w-3.5 h-3.5" />}
          Enregistrer
        </button>
        <button
          onClick={onCancel}
          disabled={busy}
          className="px-2.5 py-1.5 rounded-lg border border-slate-300 text-slate-700 text-xs hover:bg-slate-50 disabled:opacity-40"
          data-testid={`bureau-${tool}-link-cancel`}
        >
          Annuler
        </button>
      </div>
      {tip && (
        <div className="text-[10px] text-slate-400 leading-relaxed">💡 {tip}</div>
      )}
    </div>
  );
}
